import { UserType } from '../../enums/user/userType.enum';
import { NavItem } from '../../interface/nav_items/nav_items.interface';

export const NAV_ITEMS_OFFICIAL: NavItem[] = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    iconComponent: { name: 'cil-speedometer' },
    permissionCategory: 'Inicio',
    userType: UserType.OFFICIAL,
  },
  {
    name: 'Gestión Funcionarios',
    url: '/staff',
    iconComponent: { name: 'cil-user' },
    userType: UserType.OFFICIAL,
    children: [
      {
        name: 'Funcionarios',
        url: '/staff/management',
        icon: 'nav-icon-bullet',
        permissionGroup: 'Funcionarios',
        permissionCategory: 'Administración de personal',
      },
      {
        name: 'Cargos / Roles',
        url: '/staff/charges-roles',
        icon: 'nav-icon-bullet',
        permissionGroup: 'Cargos',
        permissionCategory: 'Administración de personal',
      },
      {
        name: 'Comisiones Ventas',
        url: '/staff/sales-commissions',
        icon: 'nav-icon-bullet',
        permissionGroup: ['parametrización de comisiones', 'pago de comisiones'],
        permissionCategory: 'Administración de personal',
      },
    ],
  },
  {
    name: 'Gestión Clientes',
    url: '/clients',
    iconComponent: { name: 'cil-people' },
    userType: UserType.OFFICIAL,
    children: [
      {
        name: 'Directorio',
        url: '/clients/management',
        icon: 'nav-icon-bullet',
        permissionGroup: 'Clientes',
        permissionCategory: 'Gestión de Clientes',
      },
      {
        name: 'Pagos',
        url: '/clients/client-payments',
        icon: 'nav-icon-bullet',
        permissionGroup: 'Pagos de Clientes',
        permissionCategory: 'Gestión de Clientes',
      },
    ],
  },
  {
    name: 'Gestión Proveedores',
    url: '/providers',
    iconComponent: { name: 'cil-people' },
    userType: UserType.OFFICIAL,
    children: [
      {
        name: 'Directorio',
        url: '/providers/management',
        icon: 'nav-icon-bullet',
        permissionGroup: 'Directorio de Proveedores',
      },
      {
        name: 'Pagos',
        url: '/providers/payment-services',
        icon: 'nav-icon-bullet',
        permissionGroup: 'Administración Pago Proveedores',
      },
    ],
  },
  {
    name: 'Servicios Turísticos',
    url: '/packages',
    iconComponent: { name: 'cil-calculator' },
    userType: UserType.OFFICIAL,
    children: [
      {
        name: 'Hoteles',
        url: '/packages/hotels',
        icon: 'nav-icon-bullet',
        permissionGroup: 'Hoteles',
        permissionCategory: 'Paquetes Turísticos',
      },
      {
        name: 'Alojamientos',
        url: '/packages/housing-services',
        icon: 'nav-icon-bullet',
        permissionGroup: 'Alojamientos',
        permissionCategory: 'Paquetes Turísticos',
      },
      {
        name: 'Seguros',
        url: '/packages/insurance',
        icon: 'nav-icon-bullet',
        permissionGroup: 'Seguros',
        permissionCategory: 'Paquetes Turísticos',
      },
      {
        name: 'Tiquetes',
        url: '/packages/tickets',
        icon: 'nav-icon-bullet',
        permissionGroup: 'Tiquetes',
        permissionCategory: 'Paquetes Turísticos',
      },
      {
        name: 'Toures',
        url: '/packages/tours',
        icon: 'nav-icon-bullet',
        permissionGroup: 'Toures',
        permissionCategory: 'Paquetes Turísticos',
      },
      {
        name: 'Traslados',
        url: '/packages/transport',
        icon: 'nav-icon-bullet',
        permissionGroup: 'Traslados',
        permissionCategory: 'Paquetes Turísticos',
      },
      {
        name: 'Paquetes Turísticos',
        url: '/packages/own',
        icon: 'nav-icon-bullet',
        permissionGroup: 'Paquetes Turísticos Propios',
        permissionCategory: 'Paquetes Turísticos',
      },
      {
        name: 'Paquetes Turísticos Terceros',
        url: '/packages/third-party',
        icon: 'nav-icon-bullet',
        permissionGroup: 'Paquetes Turísticos Terceros',
        permissionCategory: 'Paquetes Turísticos',
      },
      {
        name: 'Catálogo mayorista',
        url: '/packages/partner-catalog',
        icon: 'nav-icon-bullet',
        childAgencyOnly: true,
      },
    ],
  },
  {
    name: 'Cotizaciones',
    url: '/packages/quote',
    iconComponent: { name: 'cil-description' },
    userType: UserType.OFFICIAL,
    permissionGroup: 'Cotizaciones',
    permissionCategory: 'Paquetes Turísticos',
  },
  {
    name: 'Reservaciones',
    url: '/packages/reservations',
    iconComponent: { name: 'cil-calendar' },
    userType: UserType.OFFICIAL,
    permissionGroup: 'Reservaciones',
    permissionCategory: 'Paquetes Turísticos',
  },
  {
    name: 'Parametrización',
    url: '/parametrizacion',
    iconComponent: { name: 'cil-settings' },
    userType: UserType.OFFICIAL,
    children: [
      {
        name: 'Rango de Edades',
        url: '/clients/age-range',
        icon: 'nav-icon-bullet',
        permissionGroup: 'Rango de Edades',
        permissionCategory: 'Parametrización',
      },
      {
        name: 'Parametrización Base',
        url: '/packages/base',
        icon: 'nav-icon-bullet',
        permissionGroup: 'Parametrización Base',
        permissionCategory: 'Parametrización',
      },
    ],
  },
  {
    name: 'Indicadores de Gestión',
    url: '/indicators',
    iconComponent: { name: 'cil-chart' },
    userType: UserType.OFFICIAL,
    children: [
      {
        name: 'Parametrización',
        url: '/indicators/management-config',
        icon: 'nav-icon-bullet',
        permissionGroup: 'Parametrización',
        permissionCategory: 'Indicadores de Gestión',
      },
      {
        name: 'Tablero de reservas',
        url: '/indicators/reservation-board',
        icon: 'nav-icon-bullet',
        permissionGroup: 'Tablero de Reservaciones',
        permissionCategory: 'Indicadores de Gestión',
      },
    ],
  },
];
